import React, { useState } from 'react';
import { ExpandMore, ExpandLess } from '@mui/icons-material';
import { IconButton } from '@material-ui/core';
import moment, { Moment } from 'moment';

import { PERIODS_DEFINITION } from 'retired/PeriodSwitcher/periodsDefinition';

import { SingleBoxInterface } from '../ReportsBasicPage/reportsDefinition';

import SingleReportRow from './singleReportRow';

interface Props {
  reportType: SingleBoxInterface;
  organizationCreatedAt: Moment;
}

interface Range {
  year: number;
  months: number[];
}

const Monthly: React.FC<Props> = (props: Props): JSX.Element | null => {
  const { reportType, organizationCreatedAt } = props;
  const [expanded, setExpanded] = useState<number | false>(moment().year());
  const range: Range[] = Array.from(
    Array(moment().year() - (organizationCreatedAt.year() - 1)).keys()
  ).map((item: number, index: number, arr: number[]) => {
    const result: Range = {
      year: index + organizationCreatedAt.year(),
      months: Array.from(Array(12).keys()),
    };
    if (index === arr.length - 1) {
      result.months = Array.from(Array(moment().month() + 1).keys());
    }
    if (index === 0) {
      result.months = result.months.slice(organizationCreatedAt.month(), 12);
    }
    return result;
  });

  return (
    <div
      style={{
        background: 'white',
        borderBottomLeftRadius: 20,
        borderBottomRightRadius: 20,
      }}
    >
      {range.reverse().map((item: Range, index: number, yearArr: Range[]) => (
        <div
          key={item.year}
          style={{
            fontSize: 14,
            margin: '0 30px',
          }}
        >
          <div
            role="button"
            aria-hidden="true"
            onClick={(): void => {
              setExpanded(expanded === item.year ? false : item.year);
            }}
            style={{
              height: 80,
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              borderBottom: index < yearArr.length - 1 ? `1px solid #EBEEF0` : 0,
            }}
          >
            {item.year}

            <IconButton size="small">
              {expanded === item.year ? <ExpandLess /> : <ExpandMore />}
            </IconButton>
          </div>
          <div
            style={{
              padding: `0 18px`,
              maxHeight: expanded === item.year ? 80 * item.months.length : 0,
              overflow: 'hidden',
              transition: `max-height .2s ease-out`,
            }}
          >
            {item.months.reverse().map((month: number) => {
              const monthName = moment().set('month', month).format('MMMM');
              const text = `${monthName}_${item.year}_${reportType.title.split(' ').join('_')}`;
              const key = `${item.year}-${month}`;
              const monthStart = moment.utc([item.year, month]);

              return (
                <SingleReportRow
                  key={key}
                  shortText={monthName}
                  longText={text}
                  type={reportType.type}
                  fileName={`${monthName}_${item.year}_${reportType.title
                    .split(' ')
                    .join('_')}.xlsx`}
                  from={monthStart.valueOf()}
                  to={monthStart.clone().add(1, 'month').valueOf()}
                  comparison={reportType.comparison}
                  entity={reportType.entity}
                  period={PERIODS_DEFINITION.MONTH}
                />
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
};

export default Monthly;
